import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchBillingInfo } from "../../Store/Slices/Tenant/Billing";
import PayPalButton from "../../components/Vendors/PaypalButton";
import { PageHeader, EmptyState } from "../../components/ui/PageBits";

class Billing extends Component {
    state = {
        selectedAmount: null,
        confirmPay: false,
        processing: false,
    };

    componentDidMount() {
        this.props.fetchBillingInfo();
    }

    handleSelectAmount = (amount) => {
        if (this.state.processing) return;
        this.setState({ selectedAmount: amount, confirmPay: true });
    };

    handleCancel = () => {
        this.setState({ selectedAmount: null, confirmPay: false });
    };

    handleSuccess = () => {
        this.setState({ selectedAmount: null, confirmPay: false });
        this.props.fetchBillingInfo();
    };

    render() {
        const { balance, history, fixedAmounts, loading } = this.props;
        const { selectedAmount, confirmPay, processing } = this.state;

        if (loading) {
            return (
                <div className="hk-page">
                    <div className="hk-empty">
                        <div className="hk-empty-icon">💳</div>
                        <div className="font-bold text-zinc-700">Loading billing…</div>
                    </div>
                </div>
            );
        }

        return (
            <div className="hk-page">
                <PageHeader
                    eyebrow="Wallet"
                    title="Billing"
                    sub="Credits · top-ups · history"
                />

                {/* Balance + top-up */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-4">
                    <div className="hk-card hk-card-dark flex justify-between items-center">
                        <div>
                            <div className="hk-card-title" style={{ color: "#a1a1aa", marginBottom: 4 }}>
                                Available credits
                            </div>
                            <div className="text-4xl font-black hk-mono">${balance}</div>
                        </div>
                        <div className="w-12 h-12 rounded-2xl bg-[#0f172a] flex items-center justify-center text-2xl shrink-0">
                            💳
                        </div>
                    </div>
                    <div className="hk-card lg:col-span-2">
                        <div className="hk-card-title">Top up</div>
                        <div className="flex flex-wrap gap-2">
                            {fixedAmounts.map((amt) => (
                                <button
                                    key={amt}
                                    className={`hk-btn ${selectedAmount === amt && confirmPay ? "hk-btn-primary" : "hk-btn-outline"}`}
                                    onClick={() => this.handleSelectAmount(amt)}
                                    disabled={processing || confirmPay}
                                >
                                    + ${amt}
                                </button>
                            ))}
                        </div>
                        <p className="text-xs text-zinc-400 mt-3 mb-0">
                            Top-ups are processed securely via PayPal.
                        </p>
                    </div>
                </div>

                {/* Confirm Payment */}
                {confirmPay && selectedAmount && (
                    <div className="hk-card mb-4" style={{ borderColor: "var(--hk-primary-border)" }}>
                        <div className="flex flex-wrap justify-between items-center gap-3 mb-3">
                            <p className="mb-0">
                                You are about to pay <strong className="hk-mono">${selectedAmount}</strong>
                            </p>
                            <button
                                className="hk-btn hk-btn-outline hk-btn-sm"
                                onClick={this.handleCancel}
                                disabled={processing}
                            >
                                Cancel
                            </button>
                        </div>
                        <PayPalButton
                            amount={selectedAmount}
                            onSuccess={this.handleSuccess}
                        />
                    </div>
                )}

                {/* Billing History */}
                <div className="hk-table-wrap">
                    <div className="px-6 pt-5 pb-3">
                        <h5 className="hk-card-title" style={{ margin: 0 }}>Billing history</h5>
                    </div>
                    {history?.length ? (
                        <table className="hk-table">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Status</th>
                                    <th>Type</th>
                                    <th>Amount</th>
                                    <th className="text-end">Notes</th>
                                </tr>
                            </thead>
                            <tbody>
                                {history?.map((item) => {
                                    const amount = item.amount.toFixed(2);
                                    const dt = new Date(item.timestamp).toLocaleString(
                                        "en-PH",
                                        {
                                            dateStyle: "medium",
                                            timeStyle: "short",
                                        }
                                    );
                                    const credit = ["topup", "credit"].includes(
                                        item.type?.toLowerCase()
                                    );
                                    return (
                                        <tr key={item.id}>
                                            <td className="whitespace-nowrap">{dt}</td>
                                            <td>
                                                <span className="hk-pill hk-pill-zinc">{item.status}</span>
                                            </td>
                                            <td className="capitalize">{item.type}</td>
                                            <td className={`hk-mono font-bold ${credit ? "text-emerald-600" : "text-zinc-700"}`}>
                                                {credit ? "+" : "-"} ${amount}
                                            </td>
                                            <td className="text-end text-zinc-500">{item.notes}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    ) : (
                        <EmptyState
                            icon="🧾"
                            title="No billing history"
                            hint="Your top-ups and charges will appear here."
                        />
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    balance: state.billing.balance,
    history: state.billing.logs,
    fixedAmounts: state.credits.fixedAmounts,
    loading: state.credits.loading,
});

export default connect(mapStateToProps, {
    fetchBillingInfo,
})(Billing);
